import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, Navigate, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import {
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  arrayRemove,
  writeBatch,
} from "firebase/firestore";
import { firestore } from "../../firebase";
import Autocomplete from "react-google-autocomplete";
import EditMyLocation from "./editMyLocation";
import { useLanguage } from "../../LanguageContext";
import * as text from "../../translation.json";
import {
  createLocation,
  convertGoogleOpeningHours,
  fetchGoogleBusinessDetails,
} from "./utils/createLocation";

const auth = getAuth();
const db = firestore;

const MyLocations = ({ currentBusinessID }) => {
  const { language } = useLanguage();
  const [lokasjoner, setLokasjoner] = useState(false);
  const [business, setBusiness] = useState(null);
  const [newLocation, setNewLocation] = useState(false);
  const [userMenus, setUserLocations] = useState([]);
  const [user, setUser] = useState(null);
  const [locationsInfo, setLocationsInfo] = useState([]);
  const [locationType, setLocationType] = useState("");
  const [locationSecondaryType, setLocationSecondaryType] = useState("");
  const [newLocationName, setNewLocationName] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [missingFields, setMissingFields] = useState({
    type: false,
    name: false,
    lat: false,
    long: false,
    search: false,
  });
  const [googleBusinessDetails, setGoogleBusinessDetails] = useState(null);
  const [creating, setCreating] = useState(false);
  const creatingRef = useRef(false);
  const [userInformation, setUserInfomation] = useState(null);
  const [regularOpeningHours, setRegularOpeningHours] = useState({
    mon: { open: null, close: null },
    tue: { open: null, close: null },
    wed: { open: null, close: null },
    thu: { open: null, close: null },
    fri: { open: null, close: null },
    sat: { open: null, close: null },
    sun: { open: null, close: null },
  });
  const [regularClosingHours, setRegularClosingHours] = useState({
    mon: null,
    tue: null,
    wed: null,
    thu: null,
    fri: null,
    sat: null,
    sun: null,
  });

  let { edit } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    auth.onAuthStateChanged(async function (user) {
      if (user) {
        setUser(auth.currentUser);

        const userDoc = doc(db, "users", user.uid);

        const userInfo = await getDoc(userDoc);
        setUserInfomation(userInfo.data());
      } else {
      }
    });
  }, [auth]);

  useEffect(() => {
    console.log(currentBusinessID);

    const effectFunction = async () => {
      const userInfo = doc(db, "businesses", currentBusinessID);
      const userLocationList = await getDoc(userInfo);

      setUserLocations(userLocationList.data().menus);
      setBusiness(userLocationList.data());

      if (
        userLocationList.data().menus !== undefined &&
        userLocationList.data().menus.length > 0
      ) {
        fetchData(userLocationList.data().menus);
      }
    };

    // Example of a basic format check, e.g., checking if the ID is a non-empty string
    const isValidID =
      currentBusinessID &&
      typeof currentBusinessID === "string" &&
      currentBusinessID.length > 0;

    if (isValidID) {
      effectFunction();
    } else {
      console.log("Invalid business ID. Please check the ID or sign in.");
    }
  }, [currentBusinessID]);

  const fetchData = async (listData) => {
    const fetchedData = await Promise.all(
      listData.map(async (value) => {
        const docRef = doc(db, "lokasjoner", value);
        const docSnapshot = await getDoc(docRef);
        return docSnapshot;
      }),
    );

    setLocationsInfo(fetchedData);
    setLokasjoner(true);
  };

  const getGoogleBusinessDetails = (id) => {
    fetchGoogleBusinessDetails(id).then((place) => {
      setGoogleBusinessDetails(place);

      // ✅ NOW RETURNS mon–sun WITH { open, close }
      setRegularOpeningHours(convertGoogleOpeningHours(place.opening_hours));

      console.log("Google business details fetched:", place);
    });
  };

  const onAddNewLocation = async () => {
    const fields = {
      type: locationType === "",
      name: newLocationName === "",
      lat: latitude === "",
      long: longitude === "",
    };

    setMissingFields(fields);

    if (fields.type || fields.name || fields.lat || fields.long) {
      console.log("Please fill all the fields.");
      return;
    }

    console.log("Google business details:", googleBusinessDetails);

    // Creating takes a few seconds; without this, every extra click on
    // "Create" created another copy of the same location. The ref blocks
    // fast double-clicks that happen before the state update re-renders.
    if (creatingRef.current) return;
    creatingRef.current = true;
    setCreating(true);

    try {
      const { id } = await createLocation({
        currentBusinessID,
        userInformation,
        locationName: newLocationName,
        locationType,
        locationSecondaryType,
        latitude,
        longitude,
        googleBusinessDetails,
        regularOpeningHours,
        regularClosingHours,
      });

      setUserLocations((prev) => [...prev, id]);

      console.log("Data added successfully!");
      navigate("/MyBusiness/myLocations/" + id);
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      creatingRef.current = false;
      setCreating(false);
    }
  };

  const onGoBack = () => {
    setLocationType("");
    setNewLocationName("");
    setLatitude("");
    setLongitude("");
    setMissingFields({
      type: false,
      name: false,
      lat: false,
      long: false,
      search: false,
    });
    setNewLocation(false);
  };

  // const updateAllLocationOnProfile = async () => {
  //   // const apiMapping = {
  //   //   categoriesPath: "$[*]",
  //   //   categoryNamePath: "$.subCategoryName",
  //   //   itemsPath: "$.productDetails[*]",
  //   //   item: {
  //   //     allergensPath: "$.allergens[*].description",
  //   //     descriptionPath: "$.dsc",
  //   //     namePath: "$.name",
  //   //     pricePath: "$.price",
  //   //   },
  //   // };

  //   // const multipleApiURL = "https://api.peppes.no/api/products/categories-v2";
  //   // const multipleApiMappingidObjects = "categoryId";
  //   // const menuFetchUrl =
  //   //   "https://api.peppes.no/api/products/productList?productGroupId=";
  //   // const menuFetchUrlType = "multipleApi";
  //   // const menuFetchAvailable = true;

  //   const allergiesSubstitutes = {
  //     publisher: "Eier",
  //     text: "Espresso House finnes i flere land. Våre ingredienser og produktsortiment kan variere mellom landene. Les produktinformasjonen på nettsiden for det aktuelle markedet, eller på produktets emballasje hvis tilgjengelig, for å få korrekt produkt- og allergeninformasjon. Våre baristaer vil hjelpe deg med å finne informasjonen.",
  //   };

  //   const allergiesSubstitutesLang = {
  //     en_US: {
  //       publisher: "Owner",
  //       text: "Espresso House exists in several countries. Our ingredients and product range may vary between countries. Please read the product information on the website for the relevant market, or on the product packaging if available, to obtain correct product and allergen information. Our baristas will help you find the information.",
  //     },
  //     nb_NO: {
  //       publisher: "Eier",
  //       text: "Espresso House finnes i flere land. Våre ingredienser og produktsortiment kan variere mellom landene. Les produktinformasjonen på nettsiden for det aktuelle markedet, eller på produktets emballasje hvis tilgjengelig, for å få korrekt produkt- og allergeninformasjon. Våre baristaer vil hjelpe deg med å finne informasjonen.",
  //     },
  //   };

  //   await Promise.all(
  //     locationsInfo.map((lokasjonsInformasjon) => {
  //       const locationRef = doc(db, "lokasjoner", lokasjonsInformasjon.id);
  //       return updateDoc(locationRef, {
  //         allergiesSubstitutes: allergiesSubstitutes,
  //         allergiesSubstitutesLang: allergiesSubstitutesLang,
  //       });
  //     }),
  //   );
  // };

  const deleteLocation = async (id) => {
    if (
      !window.confirm(
        "Are you sure you want to delete this location? This cannot be undone",
      )
    ) {
      console.log("Deletion canceled for:", id);
      return;
    }

    try {
      // Remove from Firestore collection
      await deleteDoc(doc(db, "lokasjoner", id));

      // Remove from local array

      // Update business doc
      const userInfo = doc(db, "businesses", currentBusinessID);
      await updateDoc(userInfo, { menus: arrayRemove(id) });

      setUserLocations((prev) => prev.filter((menuId) => menuId !== id));
      setLocationsInfo((prev) => prev.filter((loc) => loc.id !== id));
      // window.location.reload();
      console.log("Deleted:", id);
    } catch (err) {
      console.error("Failed to delete location:", err);
    }
  };

  const moveActiveLocations = async () => {
    if (userInformation?.admin !== true) {
      console.log("Unauthorized attempt to move locations");
      return;
    }
    const newOwnerId = "R9mGFYbtl5AH02CaHdrk";

    const newBusinessRef = doc(db, "businesses", newOwnerId);
    const oldBusinessRef = doc(db, "businesses", currentBusinessID);

    const oldSnap = await getDoc(oldBusinessRef);
    const newSnap = await getDoc(newBusinessRef);

    let oldMenus = oldSnap.data()?.menus || [];
    let newMenus = newSnap.data()?.menus || [];

    // 👇 only active AND billed
    const eligibleLocations = locationsInfo.filter(
      (loc) => loc.data()?.active === true && loc.data()?.billed === true,
    );

    const eligibleIds = eligibleLocations.map((loc) => loc.id);

    // update menu lists
    oldMenus = oldMenus.filter((id) => !eligibleIds.includes(id));
    newMenus = [...new Set([...newMenus, ...eligibleIds])];

    const batch = writeBatch(db);

    // update each location owner
    eligibleIds.forEach((id) => {
      batch.update(doc(db, "lokasjoner", id), {
        owner: newOwnerId,
      });
    });

    // update businesses
    batch.update(oldBusinessRef, { menus: oldMenus });
    batch.update(newBusinessRef, { menus: newMenus });

    await batch.commit();

    console.log("Moved active + billed locations safely");
  };

  return edit !== undefined ? (
    <EditMyLocation currentBusinessID={currentBusinessID} />
  ) : newLocation ? (
    <>
      {/* <button
        onClick={() => {
          updateAllLocationOnProfile();
        }}>
        UpdateLocations
      </button> */}
      <div>
        <h1>{text[language].createnewlocation}</h1>
        {userInformation?.moderator && (
          <a href='/MyBusiness/locationSearch' style={{ color: "blue" }}>
            {text[language].searchforlocations}
          </a>
        )}
        <div
          className='box'
          style={{
            borderTopLeftRadius: 0,
            padding: 25,
            paddingRight: 35,
            marginBottom: "50px",
          }}>
          {!userInformation?.studentOrganisasjon && (
            <>
              <label className='editPageLabel'>
                {text[language].typeoflocation}
              </label>
              <div style={{ display: "flex", marginTop: "12px" }}>
                <div
                  style={{
                    display: "flex",
                  }}>
                  <input
                    type='checkbox'
                    className='inputCheckbox'
                    checked={locationType === "restaurant"}
                    onChange={(x) => {
                      locationType === "restaurant"
                        ? setLocationType("")
                        : setLocationType("restaurant");
                    }}
                  />
                  <label className='editPageLabel' style={{ color: "#5d3160" }}>
                    {text[language].Restaurant}
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    marginLeft: "20px",
                  }}>
                  <input
                    type='checkbox'
                    className='inputCheckbox'
                    checked={locationType === "activity"}
                    onChange={(x) => {
                      locationType === "activity"
                        ? setLocationType("")
                        : setLocationType("activity");
                    }}
                  />
                  <label className='editPageLabel' style={{ color: "#52c78c" }}>
                    {text[language].Activity}
                  </label>
                </div>
                <div
                  style={{
                    display: "flex",
                    marginLeft: "20px",
                  }}>
                  <input
                    type='checkbox'
                    className='inputCheckbox'
                    checked={locationType === "studentforening"}
                    onChange={(x) => {
                      locationType === "studentforening"
                        ? setLocationType("")
                        : setLocationType("studentforening");
                    }}
                  />
                  <label className='editPageLabel' style={{ color: "#4550e2" }}>
                    Studentforening
                  </label>
                </div>
              </div>
            </>
          )}
          {locationType === "restaurant" ? (
            <div style={{ display: "flex", marginTop: "12px" }}>
              <div
                style={{
                  display: "flex",
                }}>
                <input
                  type='checkbox'
                  className='inputCheckbox'
                  checked={locationSecondaryType === "Cafe"}
                  onChange={(x) => {
                    locationSecondaryType === "Cafe"
                      ? setLocationSecondaryType("")
                      : setLocationSecondaryType("Cafe");
                  }}
                />
                <label className='editPageLabel' style={{ color: "#5d3160" }}>
                  {text[language].kafe}
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  marginLeft: "20px",
                }}>
                <input
                  type='checkbox'
                  className='inputCheckbox'
                  checked={locationSecondaryType === "Bar"}
                  onChange={(x) => {
                    locationSecondaryType === "Bar"
                      ? setLocationSecondaryType("")
                      : setLocationSecondaryType("Bar");
                  }}
                />
                <label className='editPageLabel' style={{ color: "#52c78c" }}>
                  Bar/Pub
                </label>
              </div>
            </div>
          ) : locationType === "studentforening" ? (
            <label>
              Du har ikke tilatelse til å starte studentforening i Mapli!
              <br></br>
              Kontakt skolens studentorganisasjon eller{" "}
              <a target='_blank' href='/faq'>
                Mapli via vårt kontaktskjema
              </a>{" "}
              om du ønsker denne muligheten
            </label>
          ) : (
            <></>
          )}
          <label
            style={{
              display: missingFields.type ? "block" : "none",
              color: "#f9615b",
            }}>
            Her mangler det noe!
          </label>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "38%",
              }}>
              <label className='editPageLabel'>
                {userInformation?.studentOrganisasjon
                  ? "Navn på studentorganisasjonen"
                  : text[language].navn}
              </label>
              <input
                placeholder={text[language].navn}
                value={newLocationName}
                onChange={(x) => {
                  setNewLocationName(x.target.value);
                }}
              />
              <label
                style={{
                  display: missingFields.name ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "58%",
              }}>
              <label className='editPageLabel'>
                {userInformation?.studentOrganisasjon
                  ? "Søk på adresse eller universitet der studentorganisasjonen holder til"
                  : text[language].searchgoogle}
              </label>
              <Autocomplete
                options={{
                  types: ["places"] + ["establishment"] + ["address"],
                }}
                placeholder={
                  userInformation?.studentOrganisasjon
                    ? "Søk på adresse eller universitet der studentorganisasjonen holder til"
                    : text[language].searchgoogle2
                }
                apiKey={"AIzaSyBzqNdOb1GQUpeP2bFfsed64Yp_hEALAQ4"}
                onPlaceSelected={(place) => {
                  getGoogleBusinessDetails(place.place_id);
                  setLatitude(place.geometry.location.lat());
                  setLongitude(place.geometry.location.lng());
                }}
              />
              <label
                style={{
                  display: missingFields.search ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
            </div>
          </div>
          <div style={{ marginTop: "20px" }}>
            <label className='editPageLabel'>
              {text[language].coordinates}
            </label>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "5px",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "48%",
                }}>
                <input
                  placeholder={text[language].lengdegrad}
                  onChange={(x) => setLongitude(x.target.value)}
                  value={longitude}
                  disabled
                />
                <label
                  style={{
                    display: missingFields.long ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe! Gjør et søk på en lokasjon eller en
                  adresse!
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "48%",
                }}>
                <input
                  placeholder={text[language].breddegrad}
                  onChange={(x) => setLatitude(x.target.value)}
                  value={latitude}
                  disabled
                />
                <label
                  style={{
                    display: missingFields.lat ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe! Gjør et søk på en lokasjon eller en
                  adresse!
                </label>
              </div>
            </div>
          </div>

          <div>
            <button
              onClick={onAddNewLocation}
              className='universalButtonRed'
              style={{
                width: "150px",
                marginTop: "25px",
                marginRight: "10px",
                cursor:
                  locationType === "studentforening" || creating
                    ? "not-allowed"
                    : "pointer",
                opacity: locationType === "studentforening" || creating ? 0.5 : 1,
              }}
              disabled={locationType === "studentforening" || creating}>
              {creating ? "..." : text[language].opprett}
            </button>
            <button
              style={{
                width: "150px",
                marginTop: "25px",
              }}
              onClick={onGoBack}
              className='universalButton'>
              {text[language].cancel}
            </button>
          </div>
        </div>
      </div>
    </>
  ) : (
    <div>
      <h1>
        {userInformation?.studentOrganisasjon
          ? "Min studentforeningprofil"
          : text[language].mylocations}
      </h1>
      <button
        className='universalButton'
        style={{
          marginBottom:
            business !== null && !business.activeSub ? "20px" : "35px",
        }}
        onClick={() => {
          setNewLocation(true);
          if (userInformation?.studentOrganisasjon) {
            setLocationType("activity");
          }
        }}>
        +{" "}
        {userInformation?.studentOrganisasjon
          ? "Ny studentforening"
          : text[language].newlocation}
      </button>
      {userInformation?.moderator ? (
        <>
          <Link to='/MyBusiness/billing' style={{ color: "blue" }}>
            {text[language].tobilling}
          </Link>
        </>
      ) : (
        <></>
      )}
      {/* {business !== null && !business.activeSub ? (
        <div className='aboutLocationEditting' style={{ marginBottom: "25px" }}>
          <label>
            Du har ikke et aktivt abonnement. Aktive lokasjoner vises ikke til
            publikum.
          </label>
          <label>
            Start et nytt{" "}
            <a
              style={{
                color: "#f9615b",
              }}
              href='/MyBusiness/subscription'>
              abonnement
            </a>{" "}
            for å sette bedriften på kartet!
          </label>
        </div>
      ) : (
        <></>
      )} */}
      {lokasjoner ? (
        locationsInfo.map((lokasjonsInformasjon, rowIndex) => {
          return (
            <div
              key={rowIndex}
              className='box'
              style={{ marginBottom: "15px" }}>
              <div className='businessOverView'>
                <label className='locationNameLabel'>
                  {lokasjonsInformasjon.data()?.locationName}
                </label>
                {userInformation?.moderator ? (
                  <label
                    style={{
                      color: lokasjonsInformasjon.data()?.toReview
                        ? "#52c78c"
                        : "#f9615b",
                    }}>
                    {lokasjonsInformasjon.data()?.toReview
                      ? text[language].inreview
                      : text[language].notinreview}
                  </label>
                ) : (
                  <></>
                )}
                <label>
                  {lokasjonsInformasjon.data()?.adress
                    ? lokasjonsInformasjon.data()?.adress
                    : "-"}
                </label>
                {userInformation?.admin ? (
                  <label>
                    {lokasjonsInformasjon.data()?.menusChanged
                      ? new Date(
                          lokasjonsInformasjon.data().menusChanged,
                        ).toLocaleString("nb-NO")
                      : null}
                  </label>
                ) : (
                  <></>
                )}
                {userInformation?.moderator && (
                  <a
                    href={"#"}
                    className='universalButtonRed'
                    style={{ marginRight: "15px" }}
                    onClick={() => {
                      deleteLocation(lokasjonsInformasjon.id);
                    }}>
                    Delete Location
                  </a>
                )}
                <div>
                  <label
                    style={{
                      color: lokasjonsInformasjon.data()?.active
                        ? "#52c78c"
                        : "#f9615b",
                    }}>
                    {lokasjonsInformasjon.data()?.active
                      ? text[language].active
                      : text[language].notactive}
                  </label>
                  <a
                    href={"/MyBusiness/myLocations/" + lokasjonsInformasjon.id}
                    className='universalButtonRed'
                    style={{ marginLeft: "5px" }}>
                    {text[language].edit}
                  </a>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <p style={{ textAlign: "center", marginTop: 0 }}>
          Ingen lokasjoner å vise til
        </p>
      )}
      {userInformation?.admin && (
        <button
          onClick={() => {
            moveActiveLocations();
          }}>
          Move active locations
        </button>
      )}
    </div>
  );
};

export default MyLocations;
